import "../../assets/css/description.css";


const Description = () => {
  return (
    <>

<header className="fixed-header-image" />

      <main className="main main-raised description-container">
        <div className="container form-box">
          <div className="about-description text-center">
            <div className="row">
              <div className="col-md-12">
                <fieldset className="scheduler-border">


                  <div id="estilo1">
                    <p className="text-justify">
                      El catálogo TECTO contiene los eventos sísmicos ocurridos
                      en la zona meridional y norte del valle medio del
                      Magdalena (VMM) y La Loma, Cesar. Aquí se reportan los
                      eventos sísmicos cuya profundidad es menor a 50 km.
                      <br />
                      <br />
                      El catálogo TECTO, en su estructura principal, comprende
                      dos periodos. El primero, entre febrero 14 del 2014 y
                      diciembre de 2017. Aquí, el área de procesamiento fue
                      incrementada a medida que la red instrumental también lo
                      hizo y el procesamiento de los eventos sísmicos se
                      realizó usando el software SEISAN<sup>1</sup>. El segundo
                      periodo, desde enero de 2018 a la fecha de su última
                      actualización (31 de enero del 2021). Aquí el área de
                      procesamiento ha tenido cambios menores al igual que la
                      red instrumental, sin embargo, el procesamiento de los
                      eventos sísmicos se ha hecho usando el software
                      SeisComp3<sup>2</sup>.
                      <br />
                      <br />
                      Para los eventos localizados en la región VMM se empleó el
                      modelo de velocidades VMM (Londoño et al., 2016) y el tipo
                      de magnitud MLr_vmm (Londoño y Romero, 2017). Para los
                      eventos en la región de La Loma, Cesar, se empleó el
                      modelo de velocidades Cesar y el tipo de magnitud MLr_4
                      (Muñoz et al., 2020).
                      <br />
                      <br />
                      La red instrumental empleada para la localización de estos
                      eventos sísmicos ha crecido progresivamente desde sus
                      inicios en 2014 gracias a esfuerzos conjuntos
                      administrativos, técnicos y financieros logrados por los
                      convenios interadministrativos 060 del 2014, 261 del 2015
                      y 194 del 2016, entre el Servicio Geológico Colombiano
                      (SGC) y la Agencia Nacional de Hidrocarburos (ANH). A
                      partir de enero del 2017, esta red ha sido mantenida con
                      el esfuerzo del SGC.
                      <br />
                      <br />
                      <sup>1</sup>
                      <a
                        href="https://seisan.info/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        Seisan{" "}
                      </a>
                      El sistema de análisis sísmico SEISAN es un conjunto
                      completo de programas para el análisis de eventos sísmicos
                      obtenidos a partir de datos analógicos y digitales
                      desarrollado por GEUS.
                      <br />
                      <br />
                      <sup>2</sup>
                      <a
                        href="https://www.seiscomp3.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        SeisComP3{" "}
                      </a>
                      SeisComP3 es un software sismológico para la adquisición,
                      procesamiento, distribución y análisis interactivo de
                      datos desarrollado por GFZ y GEMPA.
                      <br />
                      <br />
                      Londoño, J., y Romero, J. (2017). Local magnitude scale
                      for Valle Medio del Magdalena region, Colombia. Journal of
                      South American Earth Sciences. 80, 237–243. Disponible en:{" "}
                      <a
                        href="https://doi.org/10.1016/j.jsames.2017.09.033"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://doi.org/10.1016/j.jsames.2017.09.033
                      </a>
                      <br />
                      <br />
                      Londoño, J., Quintero, S., Vallejo, K., Muñoz, F., y
                      Romero, J. (2016). Seismicity of Valle Medio del Magdalena
                      basin, Colombia. Journal of South American Earth Sciences,
                      92, 565–585. Disponible en:{" "}
                      <a
                        href="https://doi.org/10.1016/j.jsames.2019.04.003"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        https://doi.org/10.1016/j.jsames.2019.04.003
                      </a>
                      <br />
                      <br />
                      Muñoz Lopez, C., Velasquez, L., y Dionicio, V. (2020).
                      Calibration of Local Magnitude Scale for Colombia, Bulletin
                      of the Seismological Society of America, 110 (4), 1971–1981.
                      DOI: 10.1785/0120190226.
                    </p>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Description;